module.exports = __webpack_public_path__ + "files/CHRONOBIOLINE.ab725a230ab3e5cc5cd6a55e537117a3.zip";